import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormRegisterCertification } from 'front-office/view-models/register-certification-list';

export const transformDataset = (values: FiltersFormRegisterCertification): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.type,
      operation: Operation.EQUALS,
    },
    sigla: {
      value: otherValues.initials,
      operation: Operation.EQUALS,
    },
    descrizione: {
      value: otherValues.description,
      operation: Operation.LIKE,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    tipo: ordersToTransform.codice,
    sigla: ordersToTransform.initials,
    descrizione: ordersToTransform.description,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
